import w from "./index155.js";
import C from "./index156.js";
import E from "./index157.js";
var _ = !1, x = /[A-Z]|^ms/g, O = /_EMO_([^_]+?)_([^]*?)_EMO_/g, d = function(n) {
  return n.charCodeAt(1) === 45;
}, p = function(n) {
  return n != null && typeof n != "boolean";
}, h = /* @__PURE__ */ E(function(r) {
  return d(r) ? r : r.replace(x, "-$&").toLowerCase();
}), y = function(n, e) {
  switch (n) {
    case "animation":
    case "animationName":
      if (typeof e == "string")
        return e.replace(O, function(f, a, t) {
          return s = {
            name: a,
            styles: t,
            next: s
          }, a;
        });
  }
  return C[n] !== 1 && !d(n) && typeof e == "number" && e !== 0 ? e + "px" : e;
}, A = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function m(r, n, e) {
  if (e == null)
    return "";
  var f = e;
  if (f.__emotion_styles !== void 0)
    return f;
  switch (typeof e) {
    case "boolean":
      return "";
    case "object": {
      var a = e;
      if (a.anim === 1)
        return s = {
          name: a.name,
          styles: a.styles,
          next: s
        }, a.name;
      var t = e;
      if (t.styles !== void 0) {
        var o = t.next;
        if (o !== void 0)
          for (; o !== void 0; )
            s = {
              name: o.name,
              styles: o.styles,
              next: s
            }, o = o.next;
        var i = t.styles + ";";
        return i;
      }
      return M(r, n, e);
    }
    case "function": {
      if (r !== void 0) {
        var u = s, c = e(r);
        return s = u, m(r, n, c);
      }
      break;
    }
  }
  var l = e;
  if (n == null)
    return l;
  var v = n[l];
  return v !== void 0 ? v : l;
}
function M(r, n, e) {
  var f = "";
  if (Array.isArray(e))
    for (var a = 0; a < e.length; a++)
      f += m(r, n, e[a]) + ";";
  else
    for (var t in e) {
      var o = e[t];
      if (typeof o != "object") {
        var i = o;
        n != null && n[i] !== void 0 ? f += t + "{" + n[i] + "}" : p(i) && (f += h(t) + ":" + y(t, i) + ";");
      } else {
        if (t === "NO_COMPONENT_SELECTOR" && _)
          throw new Error(A);
        if (Array.isArray(o) && typeof o[0] == "string" && (n == null || n[o[0]] === void 0))
          for (var u = 0; u < o.length; u++)
            p(o[u]) && (f += h(t) + ":" + y(t, o[u]) + ";");
        else {
          var c = m(r, n, o);
          switch (t) {
            case "animation":
            case "animationName": {
              f += h(t) + ":" + c + ";";
              break;
            }
            default:
              f += t + "{" + c + "}";
          }
        }
      }
    }
  return f;
}
var b = /label:\s*([^\s;{]+)\s*(;|$)/g, s;
function R(r, n, e) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var f = !0, a = "";
  s = void 0;
  var t = r[0];
  if (t == null || t.raw === void 0)
    f = !1, a += m(e, n, t);
  else {
    var o = t;
    a += o[0];
  }
  for (var i = 1; i < r.length; i++)
    if (a += m(e, n, r[i]), f) {
      var u = t;
      a += u[i];
    }
  b.lastIndex = 0;
  for (var c = "", l; (l = b.exec(a)) !== null; )
    c += "-" + l[1];
  var v = w(a) + c;
  return {
    name: v,
    styles: a,
    next: s
  };
}
export {
  R as serializeStyles
};
